import { FitBoundsOptions, LatLng, LatLngBounds } from 'leaflet';
import { ActiveNodePosition, LegMarker, SimpleMarkerData } from '@features/components/LocationTracking/types';

const BOUNDS_PADDING_RATIO = 0.15;

export const TRACKING_FIT_BOUNDS_OPTIONS: FitBoundsOptions = { padding: [48, 48], maxZoom: 14 };

type TrackingBoundsInput = {
  donorMarker?: SimpleMarkerData | null;
  txCenterMarker?: SimpleMarkerData | null;
  legMarkers?: LegMarker[];
  activePosition?: ActiveNodePosition | null;
};

/**
 * Bounds covering every point the user must be able to see at once: both endpoints, each leg
 * checkpoint and the live vehicle. Polyline points are left out on purpose — the air fallback is a
 * curved arc that bows well outside the endpoints and would needlessly widen the fit.
 */
export const buildTrackingBounds = ({
  donorMarker,
  txCenterMarker,
  legMarkers,
  activePosition,
}: TrackingBoundsInput): LatLngBounds | null => {
  const points: LatLng[] = [];

  if (donorMarker) points.push(donorMarker.location);
  if (txCenterMarker) points.push(txCenterMarker.location);
  legMarkers?.forEach((marker) => points.push(marker.location));
  if (activePosition) points.push(activePosition.location);

  if (points.length === 0) return null;

  return new LatLngBounds(points).pad(BOUNDS_PADDING_RATIO);
};
